import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";

import Header from "./components/home/Header/Header";
import HeaderBottom from "./components/home/Header/HeaderBottom";
import Footer from "./components/home/Footer/Footer";
import FooterBottom from "./components/home/Footer/FooterBottom";
import SpecialCase from "./components/SpecialCase/SpecialCase";

// Pages
import Home from "./pages/Home/Home";
import Trade from "./pages/Trade/Trade";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Certificate from "./pages/Certificate/Certificate";
import WhyChooseUs from "./pages/WhyChoose/Whychooseus";
import Offer from "./pages/Offer/Offer";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Cart from "./pages/Cart/Cart";
import Enquiry from "./pages/Enquiry/Enquiry";
import Thanks from "./pages/Thanks/Thanks";
import SignUp from "./pages/Account/SignUp";
import SignIn from "./pages/Account/SignIn";
import NotFound from "./pages/NotFound";


// Layout Component for shared header/footer
const Layout = () => {
  return (
    <div className="font-bodyFont">
      <Header />
      <HeaderBottom />
      <SpecialCase />
      <ScrollRestoration />
      <Outlet />
      <Footer />
      <FooterBottom />
    </div>
  );
};

// SEO-optimized Router
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Public Layout with shared header/footer */}
      <Route path="/" element={<Layout />}>
        {/* ==================== Main Navigation Routes =================== */}
        <Route index element={<Home />} />
        <Route path="/trade" element={<Trade />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/certificate" element={<Certificate />} />
        <Route path="/whychooseus" element={<WhyChooseUs />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/product/:_id" element={<ProductDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/enquirenow" element={<Enquiry />} />
        <Route path="/thanks" element={<Thanks />} />
      </Route>

      {/* Auth Routes */}
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
